import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("App error boundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            fontFamily: "Poppins, sans-serif",
            background: "#f0f8ff",
            padding: "2em",
            textAlign: "center",
          }}
        >
          <h1 style={{ color: "#301924", marginBottom: "0.5em" }}>
            Something went wrong
          </h1>
          <p style={{ color: "#555", marginBottom: "1.5em", maxWidth: 480 }}>
            We're sorry — the page ran into an unexpected error. Please try
            refreshing, or{" "}
            <a href="/contact" style={{ color: "#8B008B" }}>
              contact us
            </a>{" "}
            if this keeps happening.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              border: "2px solid transparent",
              borderRadius: "2.5em",
              backgroundImage:
                "linear-gradient(#fff, #fff), radial-gradient(circle at bottom right, purple, orange)",
              backgroundOrigin: "border-box",
              backgroundClip: "content-box, border-box",
              cursor: "pointer",
              fontFamily: "Poppins, sans-serif",
              fontSize: "1rem",
              fontWeight: 600,
              color: "#301924",
              padding: "0.6em 2em",
            }}
          >
            Refresh page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
